import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = [
    'tabsContainer',
    'displayContainer',
  ]

  static values = {
    defaultTab: String,
  }

  declare readonly tabsContainerTarget: HTMLElement
  declare readonly displayContainerTarget: HTMLElement
  declare readonly defaultTabValue: string

  private tabs: HTMLElement[] = []
  private displayElements: HTMLElement[] = []
  private SELECTED_TAB_CLASSES = ['bg-white', 'text-black']
  private DIMMED_TAB_CLASSES = ['bg-slate-100', 'text-slate-700', 'hover:text-black', 'hover:bg-slate-200']

  connect () {
    for (const tab of this.tabsContainerTarget.children) {
      if (tab instanceof HTMLElement) {
        // Set up on-click event for tab click
        tab.onclick = this.selectTab

        // Disable clicking on any children of the tab
        for (const child of tab.children) {
          if (child instanceof HTMLElement) child.classList.add('pointer-events-none')
        }

        this.tabs.push(tab)
      }
    }

    for (const display of this.displayContainerTarget.children) {
      if (display instanceof HTMLElement) {
        this.displayElements.push(display)
      }
    }

    this.switchTab(this.defaultTabValue)
  }

  selectTab = (event: Event): void => {
    const tab = event.target as HTMLElement
    const tabName = tab.dataset.tabName

    if (tabName) {
      this.switchTab(tabName)
    }
  }

  switchTab = (tabName: string): void => {
    this.tabs.forEach(t => {
      if (t.dataset.tabName === tabName) {
        t.classList.remove(...this.DIMMED_TAB_CLASSES)
        t.classList.add(...this.SELECTED_TAB_CLASSES)
      } else {
        t.classList.remove(...this.SELECTED_TAB_CLASSES)
        t.classList.add(...this.DIMMED_TAB_CLASSES)
      }
    })

    this.displayElements.forEach(d => {
      if (d.dataset.tabName === tabName) {
        d.classList.remove('hidden')
      } else {
        d.classList.add('hidden')
      }
    })
  }
}
